import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeStringProp, makeArrayProp } from '@/utils';
import { useElementBounding } from '@vueuse/core';

const { name, bem } = createNamespaceBem('pkg-detail');

export type PkgThemeType = 'default' | 'blue' | 'orange' | 'green' | 'purple';

const pkgDetailProps = {
  theme: makeStringProp<PkgThemeType>('default'),
  title: makeStringProp(''),
  desc: makeStringProp(''),
  flag: makeStringProp(''), // 必选 可选
  tags: makeArrayProp<string>(), // xxxx;xxxx
  detail: makeStringProp(''),
};

export type PkgDetailProps = ExtractPropTypes<typeof pkgDetailProps>;

export default defineComponent({
  name,
  props: pkgDetailProps,
  setup(props) {
    const pkgBodyRef = ref(null);
    const pkgBodyWrapRef = ref(null);
    const pkgExpand = ref<boolean>(false);

    const triggerExp = () => {
      pkgExpand.value = !pkgExpand.value;
    };

    const { height: bodyH } = useElementBounding(pkgBodyRef);
    const { height: bodyWrapH } = useElementBounding(pkgBodyWrapRef);

    onMounted(() => {
      if (bodyH.value > bodyWrapH.value) {
        triggerExp();
      }
    });

    return () => (
      <div class={bem([props.theme, { expand: pkgExpand.value }])}>
        <div class={bem('header')}>
          <div class={bem('title')}>{props.title}</div>
          <div class={bem('flag')}>{props.flag}</div>
        </div>
        <div class={bem('body')} ref={pkgBodyRef}>
          <div class={bem('body-wrap')} ref={pkgBodyWrapRef}>
            <div class={bem('tags')}>
              {props.tags.map((i) => (
                <span class={bem('tag')}>{i}</span>
              ))}
            </div>
            <div class={bem('detail')}>
              {props.detail.split('\n').map((i) => (
                <p>{i}</p>
              ))}
            </div>
          </div>
          <div class={bem('expand')} onClick={triggerExp}>
            查看全部
          </div>
        </div>
      </div>
    );
  },
});
